import React from 'react';
import { Fragment } from 'react';
import {
    Datagrid,
    List,
    TextField,
    Button,
    useNotify,
    useRefresh,
    useUnselectAll,
    useUpdateMany,
    NumberField,
    usePermissions,
    useDataProvider,
    DateField} from 'react-admin';
import exporterCommon from "../import/exporterCommon";

import MultiCurrencyField from "../../UIComponents/multiCurrencyField";


const ResroteButton = ({ label, selectedIds, loading, redirect, record }) => {
    // const {, record,redirect,id, } = props
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();

    // const [updateMany] = useUpdateMany(
    //     'payrollRuns',
    //     selectedIds,
    //     { isDeleted: false },
    //     {
    //         onSuccess: () => {
    //             refresh();
    //             notify("Payroll Run Restored");
    //             unselectAll('deletedPayrollRuns');
    //         },
    //         onFailure: error => notify('Error: Payroll Could Not be Restored', 'warning'),
    //     }
    // );

    const dataProvider = useDataProvider();

    const restoreSelected = async () => {
        try {
            const res = await dataProvider.serverActionMany('payrollRuns', { ids: selectedIds, action: "Restore" });
            refresh();
            notify("Payroll Run Restored");
            unselectAll('deletedPayrollRuns');
        } catch (error) {
            console.error(error)
            notify('Error: Payroll Could Not be Restored', 'warning');
        }
    }


    return (
        <Button
            label={label}
            onClick={restoreSelected}
        >
            
        </Button>
    );
};

const BulkActionButtons = props => (
    <Fragment>
        <ResroteButton label="Restore Selected" {...props} />
    </Fragment>
);



export const DeletedPayrunList = props => (
    <List
        filter={
            props.permissions && (props.permissions.includes('Manager') || props.permissions.includes('DManager'))
                ? undefined
                : { modifiedBy: localStorage.getItem('user') }
        }
        exporter={exporterCommon(props.resource)}
        {...props}
        bulkActionButtons={<BulkActionButtons />}
        sort={{ field: 'runDate', order: 'DESC' }}
    >
      <Datagrid {...props}>
        <NumberField source="id"/>
<DateField source="runDate" showTime/>
<DateField source="payrollDate" options={{year: 'numeric', month: 'long'}} label="Payroll Month"/>
<TextField source="createdBy"/>
<TextField source="modifiedBy"/>
<TextField source="status"/>
<MultiCurrencyField source="cash" label="Net"/>

</Datagrid>
    </List>
);
